module.exports = __webpack_public_path__ + "img/reject.37a4c217.png";